import { isOn } from './helpers.js';
export const isToBn = /*#__PURE__*/ isOn('toBn');
